import { useEffect, useState } from "react";
import { Flex, Button, Form, Switch, ConfigProvider, Tag } from "antd";
import TagBordered from "../../../../../../atom/TagBordered";

import StyledModal from "./style";

import { getVisibleProducts } from "../../helper";

const ModalEnableInvestments = ({
  loading,
  onCancel,
  onSuccess,
  open,
  products,
  productsList,
}) => {
  const [form] = Form.useForm();
  const [enabledInvestments, setEnabledInvestments] = useState({});
  const [filteredProducts, setFilteredProducts] = useState();

  useEffect(() => {
    if (!open || !productsList) return;

    const assets = [...new Set(productsList.map(it => it.assetManager))].sort(
      (a, b) => a.localeCompare(b)
    );

    const categories = [
      ...new Set(productsList.map(it => it.broadCategory)),
    ].sort((a, b) => a.localeCompare(b));

    const types = [...new Set(productsList.map(it => it.type))].sort((a, b) =>
      a.localeCompare(b)
    );

    setEnabledInvestments({
      assets,
      categories,
      types,
    });

    if (products) {
      const filters = {};

      products.assets.map(it => (filters[`assets__${it.name}`] = it.enabled));

      products.categories.map(
        it => (filters[`categories__${it.name}`] = it.enabled)
      );

      products.types.map(it => (filters[`types__${it.name}`] = it.enabled));

      setFilteredProducts(
        getVisibleProducts({
          filters: parseFormValues(filters),
          productsList,
        })
      );

      form.setFieldsValue(filters);
    }
  }, [open]);

  const handleDeselectAll = type => {
    const updatedFields = {};

    products[type].map(it => (updatedFields[`${type}__${it.name}`] = false));

    form.setFieldsValue(updatedFields);
  };

  const onFormValueChange = (_, allValues) => {
    setFilteredProducts(
      getVisibleProducts({
        filters: parseFormValues(allValues),
        productsList,
      })
    );
  };

  const parseFormValues = values => {
    const getValuesBySearchParam = searchParam =>
      Object.keys(values)
        .filter(it => it.includes(searchParam))
        .map(key => ({
          name: key.split("__")[1],
          enabled: values[key] ?? false,
        }));

    return {
      assets: getValuesBySearchParam("assets__"),
      categories: getValuesBySearchParam("categories__"),
      types: getValuesBySearchParam("types__"),
    };
  };

  const GroupItems = ({ showDeselectAll, showTagLabels, title, type }) => (
    <Flex vertical>
      <Flex
        align="center"
        style={{
          borderBottom: "1px solid #A5A3A3",
          color: "#4B4747",
          paddingBottom: 4,
          marginBottom: 8,
        }}
        justify="space-between"
      >
        {title}

        {showDeselectAll && (
          <Button
            onClick={() => handleDeselectAll(type)}
            shape="round"
            size="small"
            style={{ color: "#A5A3A3" }}
            type="text"
          >
            Deselect All
          </Button>
        )}
      </Flex>

      {enabledInvestments[type]?.map((label, index) => (
        <Form.Item
          colon={false}
          label={showTagLabels ? <TagBordered label={label} /> : label}
          labelCol={{ style: { order: 2 } }}
          key={index}
          name={`${type}__${label}`}
          valuePropName={"checked"}
        >
          <Switch />
        </Form.Item>
      ))}
    </Flex>
  );

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            disabled={loading}
            form="formEnableInvestments"
            htmlType="submit"
            shape="round"
            type="primary"
          >
            Update
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title="Enable Investments"
      width={691}
    >
      <ConfigProvider
        theme={{
          components: {
            Switch: {
              colorPrimary: "#019A00",
              colorPrimaryHover: "#019A00",
            },
          },
        }}
      >
        <Form
          form={form}
          id="formEnableInvestments"
          onFinish={values =>
            onSuccess({
              ...parseFormValues(values),
              investmentsEnabled: filteredProducts?.length,
            })
          }
          onValuesChange={onFormValueChange}
        >
          <Flex gap={24} vertical>
            <Flex
              align="center"
              gap={4}
              style={{
                borderRadius: 12,
                background: "#F8F8F8",
                padding: "8px 16px",
              }}
            >
              Investments enabled:
              <b style={{ fontSize: 19 }}>{filteredProducts?.length}</b>
            </Flex>

            <Flex gap={32} justify="space-between">
              <Flex
                gap={32}
                style={{
                  width: 300,
                }}
                vertical
              >
                <GroupItems showDeselectAll title="Type" type="types" />
              </Flex>

              <Flex style={{ width: 300 }} vertical>
                <GroupItems
                  showDeselectAll
                  showTagLabels
                  title="Categories"
                  type="categories"
                />
              </Flex>
            </Flex>

            <GroupItems showDeselectAll title="Asset Manager" type="assets" />
          </Flex>
        </Form>
      </ConfigProvider>
    </StyledModal>
  );
};

export default ModalEnableInvestments;
